import { pick } from 'ramda'

const getFirstMessageFromMessagesArray = (messagesArray): any => {
  if (!messagesArray || !Array.isArray(messagesArray) || messagesArray.length === 0) {
    return null
  }

  return pick(['code', 'details', 'target', 'message'], messagesArray[0])
}

export default getFirstMessageFromMessagesArray
